/**
 * @file Entrypoint for the `@openshift-console/dynamic-plugin-sdk-internal` package published to npmjs.
 *
 * Internal package exposing additional code.
 */

export * from './api/internal-api';
